<!--
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-08-26 18:15:08
 * @LastEditTime: 2021-01-20 11:34:52
 * @LastEditors: daikeyi
 -->
<template>
    <div id="page_Container" style='margin-bottom:60px;' class='orderDetails'>
        <div class="page">
            <div id='main-container' class="main-container">
                <div class='jyType'>
                    <van-row>
                        <van-col span="14" class='colLeft'>
                            <p>{{dataDetails.statusStr}}</p>
                            <div class="statusStr" v-if="dataDetails.lockFlag !== 0">{{getStatusStr(dataDetails)}}</div>
                            <p v-if="dataDetails.status===orderStatus.pendingReceipt && dataDetails.deliveryTime">还剩{{limitTime.days}}天{{limitTime.hours}}小时自动确认</p>
                        </van-col>
                        <van-col span="10" class='colRight'>
                            <img :src="imgUrl" class='imgStyle' alt="">
                        </van-col>
                    </van-row>
                </div>
                <div class='transactionInfo' v-if='dataDetails.deliveryMethodCode === "COME_ON"'>
                    <p class='pW'>
                        <span class='name'>网点员工名称：{{dataDetails.merchantOutlet.sender}}</span>
                        <span class='phone'>{{dataDetails.merchantOutlet.phone}}</span>
                    </p>
                    <p class='pT'>
                        <span>自提网点：{{dataDetails.merchantOutlet.outletName}}</span>
                    </p>
                    <div class='address'>
                        <p class='pLocation'>
                            <van-icon name="location" />
                        </p>
                        <p class='pAddress'>网点地址：{{dataDetails.merchantOutlet.area}}{{dataDetails.merchantOutlet.address}}</p>
                    </div>
                </div>
                <div class='transactionInfo' v-else>
                    <p class='pPeople'>
                        <span class='spanPeople'>{{dataDetails.receiver}}</span>
                        <span class='spanPhone'>{{dataDetails.mobileNumber}}</span>
                    </p>
                    <div class='address'>
                        <p class='pLocation'>
                            <van-icon name="location" />
                        </p>
                        <p class='pAddress'>{{dataDetails.area}}{{dataDetails.address}}</p>
                    </div>
                </div>
                <div class='commodityDetails'>
                    <p class='title'>
                        <img class='kdImg' v-if='dataDetails.deliveryMethodCode === "EXPRESS_DELIVERY"' :src="kd" alt="">
                        <img :src="ps" v-if='dataDetails.deliveryMethodCode === "EXPRESS_DISTRIBUTION"' alt="">
                        <img v-if='dataDetails.deliveryMethodCode === "COME_ON"' :src="zt" alt="">
                        <img :src="zy" v-if='dataDetails.deliveryMethodCode === "TRANSPORT_DIRECT"' alt="">
                        <span>{{dataDetails.businessTypeStr + dataDetails.deliveryMethod}}</span>
                    </p>
                    <div v-for='(item, index) in dataDetails.memberOrderItemList' :key='item.id'>
                        <van-card :desc="item.specificationValue" :title="item.productName" :thumb="item.productImg">
                            <template slot='desc'>
                                <div @click="godetail(item)">
                                    <p class='descP'>{{item.specificationValue}}</p>
                                    <p class='numP'>
                                        <span class='p1'>￥{{ESVBase.numberTofixed(item.productPrice)}}</span>
                                        <span class='p2'>×{{item.quantity}}</span>
                                    </p>
                                    <!-- <div class='boxStatus'>
                                        <p v-if='item.status ==="2" || item.status ==="4" || item.status ==="3"' class='statusP'>
                                            <span>{{item.statusStr}}</span>
                                        </p>
                                    </div> -->
                                </div>
                            </template>
                        </van-card>
                        <div class='refundBox'>
                            <BtnAss :text='invoiceBtnText' :type='1' v-if="invoiceBtnShow" @fromChildClick="invoiceClick(item, index)"></BtnAss>
                            <BtnAss :text='thText' :type='1' v-if="showAfterSaleBtn" @fromChildClick='openAfterSales(item, index)'></BtnAss>
                        </div>
                        <div class='refundP' v-if='dataDetails.status === orderStatus.closed'>
                            <p v-if='item.status ==="2"' class='statusP'>
                                <span>{{item.statusStr}}</span>
                            </p>
                        </div>
                    </div>

                    <div class='commodityPrice'>
                        <p>
                            <span class='pull-left'>物流方式</span>
                            <span class='pull-right'>{{dataDetails.deliveryMethod}}</span>
                        </p>
                        <p v-if="dataDetails.deliveryMethodCode === 'COME_ON'">
                            <span class='pull-left'>自提网点</span>
                            <span class='pull-right'>{{dataDetails.outletName}}</span>
                        </p>
                        <p>
                            <span class='pull-left'>物流运费</span>
                            <span class='pull-right'>{{dataDetails.freightAmount !== undefined && dataDetails.freightAmount !== 0 ? '¥' + ESVBase.numberTofixed(dataDetails.freightAmount) : '¥0.00'}}</span>
                        </p>
                        <p>
                            <span class='pull-left'>套装优惠</span>
                            <span class='pull-right'>{{dataDetails.groupBenefitAmount !== undefined && dataDetails.groupBenefitAmount !== 0 ? '- ¥' + (dataDetails.groupBenefitAmount).toFixed(2) : '¥0.00'}}</span>
                        </p>
                        <p>
                            <span class='pull-left'>活动优惠</span>
                            <span class='pull-right'>{{dataDetails.shopDiscountAmount !== undefined && dataDetails.shopDiscountAmount !== 0 ? '- ¥' + (dataDetails.shopDiscountAmount).toFixed(2) : '¥0.00'}}</span>
                        </p>
                        <p>
                            <span class='pull-left'>优惠券抵扣</span>
                            <span class='pull-right'>{{dataDetails.couponDiscountAmount !== undefined && dataDetails.couponDiscountAmount !== 0 ? '- ¥' + (dataDetails.couponDiscountAmount).toFixed(2) : '¥0.00'}}</span>
                        </p>
                        <p>
                            <span class='pull-left'>积分抵扣</span>
                            <span class='pull-right'>{{dataDetails.maxDeductionAmount !== undefined && dataDetails.maxDeductionAmount !== 0 ? '- ¥' + (dataDetails.maxDeductionAmount).toFixed(2) : '¥0.00'}}</span>
                        </p>
                    </div>
                    <div class='orderPrice'>
                        <p>
                            <span class='pull-left'>实付款(含运费)</span>
                            <span class='pull-right'>¥{{ESVBase.numberTofixed(dataDetails.payAmount)}}</span>
                        </p>
                    </div>
                </div>
                <div class='orderMessage'>
                    <p>订单编号：<span id='spanId'>{{dataDetails.orderCode}}</span><span class='fz' @click='copyText'>复制</span></p>
                    <!-- <p v-if='dataDetails.transactionId'>交易流水号：{{dataDetails.transactionId}}</p>
                    <p>创建时间：{{dataDetails.createTime}}</p> -->
                    <p v-if='dataDetails.paymentTime'>付款时间：{{dataDetails.paymentTime}}</p>
                    <p v-if='dataDetails.deliveryTime'>发货时间：{{dataDetails.deliveryTime}}</p>
                    <!-- <p v-if='dataDetails.transactionTime'>成交时间：{{dataDetails.transactionTime}}</p> -->
                </div>
                <div class='lxkf'>
                    <p>
                        <a :href='contactCustomer'>
                            <span>联系客服</span>
                            <img :src="kfUrl" alt="">
                        </a>
                    </p>
                </div>
            </div>
            <div :class='{buttonStyle: dataDetails.status !== orderStatus.toDeliver}'>
                <div v-if='dataDetails.status === orderStatus.unpay'>
                    <BtnAss :text='textParentCancel' :type='1' @fromChildClick='cancelOrder(dataDetails)'></BtnAss>
                    <BtnAss :text='payParent' :type='2' @fromChildClick='paymentClick(dataDetails)'></BtnAss>
                </div>
                <!-- TODO 提醒发货 -->
                <!-- <div v-if='dataDetails.status === orderStatus.toDeliver'>
                    <BtnAss :text='txText' :type='2' @fromChildClick='shipmentClick(dataDetails)'></BtnAss>
                </div> -->
                <div v-if='dataDetails.status === orderStatus.pendingReceipt'>
                    <BtnAss :text='watchWl' v-if='dataDetails.deliveryMethodCode !== "COME_ON"' :type='1' @fromChildClick='queryLogistics(dataDetails)'></BtnAss>
                    <BtnAss :text='okProduct' :type='2' @fromChildClick='collectGoods(dataDetails)'></BtnAss>
                </div>
                <div v-if='dataDetails.status === orderStatus.comment'>
                    <BtnAss :text='watchWl' v-if='dataDetails.deliveryMethodCode !== "COME_ON"' :type='1' @fromChildClick='queryLogistics(dataDetails)'></BtnAss>
                    <BtnAss :text='deleteText' :type='1' @fromChildClick='deleteOrder(dataDetails)'></BtnAss>
                    <BtnAss :text='pjText' :type='2' @fromChildClick='openEvaluate(dataDetails)'></BtnAss>
                </div>
                <div v-if='dataDetails.status === orderStatus.closed'>
                    <BtnAss :text='deleteText' :type='1' @fromChildClick='deleteOrder(dataDetails)'></BtnAss>
                </div>
                <div v-if='dataDetails.status === orderStatus.completde'>
                    <BtnAss :text='deleteText' :type='1' @fromChildClick='deleteOrder(dataDetails)'></BtnAss>
                    <BtnAss :text='watchWl' v-if='dataDetails.deliveryMethodCode !== "COME_ON"' :type='1' @fromChildClick='queryLogistics(dataDetails)'></BtnAss>
                </div>
            </div>
        </div>
        <wxShareLoading></wxShareLoading>
    </div>
</template>
<script>
import * as orderStatus from '@/assets/js/const.js';
import BtnAss from '@/components/common/btnAss';
import { toastLoading, clearToastLoading, confirmModal } from '@/utils/base/utils';
import { mapState, mapMutations, mapGetters } from 'vuex';

const DAYS = 15;
export default {
    components: {
        BtnAss,
        wxShareLoading: () => import('@/components/common/wxShareLoading')
    },
    data() {
        return {
            // merchantInfo: {},
            orderStatus: { ...orderStatus },
            contactCustomer: '',
            textId: false,
            textParentCancel: '取消订单',
            payParent: '付款',
            txText: '提醒发货',
            watchWl: '查看物流',
            okProduct: '确认收货',
            deleteText: '删除订单',
            pjText: '评价',
            thText: '售后',
            commodityUrl: require('../assets/img/myCenter/commodity.png'),
            titleUrl: require('../assets/img/myCenter/titleBg.png'),
            imgUrl: require('../assets/img/myCenter/fahuo.png'),
            kfUrl: require('../assets/img/myCenter/kf.png'),
            ps: require('../assets/img/myCenter/ps.png'),
            kd: require('../assets/img/myCenter/kd.png'),
            zt: require('../assets/img/myCenter/zt.png'),
            zy: require('../assets/img/myCenter/zy.png'),
            dataDetails: {},
            limitTime: {
                days: 0,
                hours: 0
            }
        };
    },
    esvReady: function() {
        // this.getMerchantInfo();
    },
    esvShow: function() {
        document.title = '订单详情';
        this.dataDetails = this.orderDetails;

        let channelType = 'WECHAT';
        this.ESVStorage.getSessionValue('channelType', (data) => {
            channelType = data || '';
        });

        if (channelType.indexOf('APP') < 0) {
            this.contactCustomerLink();
        }
        // this.dataDetails.deliveryTime = '2019-06-20 17:50:45';
        if (this.dataDetails.deliveryTime) {
            this.convertTime(this.dataDetails.deliveryTime);
        }
    },
    methods: {
        ...mapMutations(['setChoiceGoodsItem']),
        // getMerchantInfo() {
        //     this.ESVStorage.getSessionValue('merchantInfo', (merchantInfo) => {
        //         if (merchantInfo) {
        //             this.merchantInfo = merchantInfo;
        //         } else {
        //             this.$doRequest(
        //                 { url: '/merchant/getMerchantInfo', params: {} },
        //                 (data) => {
        //                     this.merchantInfo = data.result;
        //                     this.ESVStorage.putSessionValue('merchantInfo', this.merchantInfo);
        //                 }
        //             );
        //         }
        //     });
        // },
        invoiceClick(item, index) {
            console.log(item, index);
            if (this.dataDetails.invoiceType === 0) {
                this.esvOpenPage({ name: 'OPInvoice', params: { orderCode: item.orderCode, totalAmount: this.dataDetails.payAmount, type: '1' } });
            } else {
                this.esvOpenPage({ name: 'OPInvoiceDetails', params: { orderCode: item.orderCode, invoiceSerialNumber: this.dataDetails.invoiceSerialNumber } });
            }
        },
        getStatusStr(dataDetails) {
            const { lockFlag } = dataDetails;
            let statusStr = '';
            switch (lockFlag) {
            case 1:
                statusStr = '退货审核中';
                break;
            case 2:
                statusStr = '退货审核通过';
                break;
            default:
                statusStr = '';
                break;
            }
            return statusStr;
        },
        convertTime(time) {
            if (time) {
                time = time.replace(/-/g, '/');
                console.log(time);
                const deliveryMill = new Date(time).getTime();
                const nowMill = new Date().getTime();
                const diff = (DAYS * 1000 * 60 * 60 * 24) - (nowMill - deliveryMill);
                const days = Math.floor(diff / (1000 * 60 * 60 * 24));
                const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
                this.limitTime = {
                    days,
                    hours
                };
            }
        },
        // 查询链接
        contactCustomerLink() {
            const ths = this;
            const params = {

            };
            // if (ths.$route.query.productId) {
            // let token = ths.getPramVal('token');
            // params.token = token;
            // }
            ths.$doRequest({
                url: '/merchant/contactCustomer',
                params: params,
                before: function() {
                    ths.loading = toastLoading();
                },
                complete: function() {
                    clearToastLoading(ths.loading);
                }
            },
            function (data) {
                ths.contactCustomer = data.result;
            }
            );
        },
        getPramVal(name) {
            const reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
            const str =
                window.location.href.indexOf('?') === -1
                    ? ''
                    : window.location.href.slice(
                        window.location.href.indexOf('?'),
                        window.location.href.length
                    );
            const r = str.substr(1).match(reg);
            if (r != null) {
                return decodeURI(r[2]);
            }
            return null;
        },
        // 按钮操作
        cancelOrder(item) {
            const ths = this;
            confirmModal('确定要取消订单吗？', function() {
                const params = {
                    orderCode: item.orderCode
                };
                ths.$doRequest(
                    {
                        url: '/order/cancelOrder',
                        params: params,
                        before: function() {
                            ths.loading = toastLoading();
                        },
                        complete: function() {
                            clearToastLoading(ths.loading);
                        }
                    },
                    function(data) {
                        if (data.responseCode === '100000') {
                            ths.$toast('订单已取消');
                            setTimeout(function() {
                                ths.$router.go(-1);
                            }, 1200);
                        }
                    }
                );
            });
        },
        paymentClick(item) {
            console.log(item);
            const orderInfo = {
                orderCode: item.orderCode,
                sumPayAmount: item.payAmount
            };
            this.ESVStorage.putSavedValue('orderInfo', orderInfo);

            let channelType = 'WECHAT';
            this.ESVStorage.getSessionValue('channelType', (data) => {
                channelType = data;
            });
            if (channelType === 'APP') {
                this.esvOpenPage({ name: 'OPPayorder' });
            } else {
                this.getIndexUrl();
            }
        },
        // 二次鉴权
        getIndexUrl() {
            const params = {
                url: '#/OPPayorder?esvOAuthUrlIndex=1'
            };
            this.$doRequest(
                {
                    url: '/oauth/getActualOAuthUrl',
                    params: params,
                    complete: function() {
                    }
                },
                function(data) {
                    // sessionStorage.setItem('isIndex', '1');
                    window.location.href = data.result;
                }
            );
        },
        collectGoods(item) {
            const ths = this;
            ths.ESVStorage.putSavedValue('productData', item);
            confirmModal('确定收货吗？', function() {
                const params = {
                    orderCode: item.orderCode
                };
                ths.$doRequest(
                    {
                        url: '/order/confirmOrder',
                        params: params,
                        before: function() {
                            ths.loading = toastLoading();
                        },
                        complete: function() {
                            clearToastLoading(ths.loading);
                        }
                    },
                    function(data) {
                        ths.$toast.success('收货成功');
                        ths.esvOpenPage('OPDeliverySuccess');
                    }
                );
            });
        },
        // 提醒发货
        shipmentClick(item) {
            const ths = this;
            const params = {
                orderCode: item.orderCode
            };
            this.$doRequest(
                {
                    url: '/order/remindDelivery',
                    params: params,
                    before: function() {
                        ths.loading = toastLoading();
                    },
                    complete: function() {
                        clearToastLoading(ths.loading);
                    }
                },
                function(data) {
                    ths.$toast.success('提醒成功');
                }
            );
        },
        // 删除订单
        deleteOrder(item) {
            const ths = this;
            confirmModal('确认删除订单吗？', function() {
                const params = {
                    orderCode: item.orderCode
                };
                ths.$doRequest(
                    {
                        url: '/order/deleteMemberOrder',
                        params: params,
                        before: function() {
                            ths.loading = toastLoading();
                        },
                        complete: function() {
                            clearToastLoading(ths.loading);
                        }
                    },
                    function(data) {
                        ths.$toast('删除订单成功');
                        // ths.esvReloadPage();
                        ths.esvBackPage(1);
                    }
                );
            });
        },
        // 查看物流
        queryLogistics(item) {
            this.ESVStorage.putSavedValue('orderCode', item.orderCode);
            this.esvOpenPage({ name: 'OPLogisticsList', params: { orderCode: item.orderCode } });
            // let ths = this;
            // let params = {
            //     orderCode: item.orderCode
            // };
            // ths.$doRequest(
            //     {
            //         url: '/order/queryLogisticsOrderList',
            //         params: params,
            //         complete: function() {}
            //     },
            //     function(data) {
            //         ths.ESVStorage.putSavedValue(
            //             'logList',
            //             data.result
            //         );
            //         ths.esvOpenPage('OPLogisticsList');
            //     }
            // );
        },

        openAfterSales(item, index) {
            this.setChoiceGoodsItem({ choiceGoodsItem: item });
            this.esvOpenPage('OPChoiceAfterSalesService');
        },
        openEvaluate(item) {
            this.ESVStorage.putSavedValue('productData', item);
            this.esvOpenPage('OPEvaluate');
        },
        // 到商品详情
        godetail: function(item) {
            const ths = this;
            ths.ESVStorage.putSavedValue('goodsId', item.productId);
            ths.esvOpenPage({
                name: 'OPGoodsdetail',
                params: { goodsId: item.productId }
            });
        },
        copyText() {
            var copyDOM = document.getElementById('spanId');
            var range = document.createRange();
            window.getSelection().removeAllRanges();
            range.selectNode(copyDOM);
            window.getSelection().addRange(range);
            var successful = document.execCommand('copy');
            if (successful) {
                this.$toast('已复制');
            }
            // 移除选中的元素
            window.getSelection().removeAllRanges();
        }
    },
    computed: {
        ...mapState({ orderDetails: state => state.order.orderDetails }),
        ...mapGetters(['merchantInfo']),
        showAfterSaleBtn() {
            return this.dataDetails.status !== this.orderStatus.unpay && this.dataDetails.status !== this.orderStatus.closed && this.dataDetails.type !== 3;
        },
        invoiceBtnShow() {
            // return this.dataDetails.status === this.orderStatus.comment || this.dataDetails.status === this.orderStatus.completde;
            // return (this.dataDetails.status === this.orderStatus.comment || this.dataDetails.status === this.orderStatus.completde) && this.dataDetails.payAmount !== 0 && this.dataDetails.invoiceType !== 2;
            return (this.dataDetails.status === this.orderStatus.comment || this.dataDetails.status === this.orderStatus.completde) && this.dataDetails.payAmount !== 0 && Number(this.merchantInfo.isSupportInvoice) === 1;
        },
        invoiceBtnText() {
            if (this.dataDetails.invoiceType === 0) {
                return '申请发票';
            } else {
                return '查看发票';
            }
        }
    }
};
</script>
<style lang="scss" scoped>
.buttonStyle {
    position: fixed;
    bottom: 0;
    left: 0;
    background: #fff;
    width: 100%;
    height: 60px;
    line-height: 60px;
    text-align: right;
    padding: 0 12px;
}
.jyType {
    background: #ee2e50;
    color: white;
    font-size: 12px;
    padding:10px 35px;
    p{

    }
}
.transactionInfo {
    padding: 12px;
    background: url(../assets/img/myCenter/bottomBg.png) no-repeat center
        bottom white;
    background-size: contain;
    .address {
        overflow: hidden;
        .pLocation {
            width: 6%;
        }
        .pAddress {
            width: 92%;
        }
        p {
            float: left;
            min-height: 52px;
        }
    }
    p {
        font-size: 14px;
        padding: 5px 0;
        .van-icon {
            float: left;
            margin-top: 3px;
        }
    }
}
.commodityDetails {
    margin-top: 12px;
    padding: 0 0 12px 0;
    background: #fff;
    .commodityPrice {
        margin: 12px 0;
        p {
            overflow: hidden;
            color: #999999;
            padding: 0 12px;
        }
    }
    .orderPrice {
        p {
            overflow: hidden;
            padding: 0 12px;
            font-size:14px;
        }
        .pull-right{
             color: #ee2e50;
        }
    }
    .numP {
        .p1 {
            float: left;
            color: #ee2e50;
        }
        .p2 {
            float: right;
            color: #999;
        }
    }
    .boxStatus {
        text-align: right;
    }
}
.orderMessage {
    background: white;
    margin-top: 12px;
    padding: 12px;

    p {
        color: #999;
    }
}
.lxkf{
    margin-bottom:60px;
    padding:12px;
    text-align: right;
    background: #fff;
    border-top: 1px solid #E3E2E2;
    p{
        overflow: hidden;
        img{
            width:17px;
            float: right;
            margin-right:5px;
        }
        span{
            color:#666;
             float: right;
        }
    }
}
.hotsaleProduct {
    h5 {
        text-align: center;
        color: #ee2e50;
        height: 20px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 12px 0;
        img {
            width: 15px;
            margin: 0 3px;
        }
    }
    .product {
        background: #fff;
        margin-bottom: 5px;
        .imgBox {
            text-align: center;
            padding: 10px;
            img {
                width: 100%;
                height: 160px;
            }
        }
        .title {
            padding: 10px;
            font-size: 14px;
            height: 56px;
            text-overflow: -o-ellipsis-lastline;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            line-clamp: 2;
            -webkit-box-orient: vertical;
        }
        .price {
            padding: 0 10px 10px 10px;
        }
    }
}
.transactionInfo {
    .pT {
        overflow: hidden;
        span {
            float: left;
            margin-left: 6%;
        }
    }
    .pW {
        overflow: hidden;
        .name {
            float: left;
            margin-left: 6%;
        }
        .phone {
            float: right;
            margin-right: 10px;
        }
    }
    .pPeople {
        overflow: hidden;
        .spanPeople {
            float: left;
            margin-left: 6%;
            padding-right:30px;
        }

    }
}
.refundBox {
    text-align: right;
    padding: 5px 12px;
}
.refundP {
    text-align: right;
    padding: 5px 12px;
}
.commodityDetails {
    .descP {
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 1 !important;
        -webkit-box-orient: vertical;
        margin-top: 2px;
        color: #999;
    }
}
.colLeft{
    p{
        padding-top:9px;
    }
    .statusStr {
        color: #f8c367;
        font-size: 10px;
        margin-top: 3px;
    }
}
.colRight{
    text-align: center;
    img{
        width:84px;
    }
}
.fz{
     color: #ee2e50;
     float: right;
}
.title{
    padding:12px;
    overflow: hidden;
    img{
        width:18px;
        float: left;
        margin-right:10px;
        margin-top:2px;
    }
    span{
        float:left;
    }
}
.kdImg{
    margin-top:3px;
}
</style>
